export default __webpack_public_path__ + "static/media/postman.079e78a2.jpg";